import toast from 'react-hot-toast';

export const errorHandler = (error: any) => {
  console.error('Error: ', error);
  if (process.env.REACT_APP_ENV === 'development') {
    toast.error(error.message);
  }
};
